import Table from 'common/ui/components/Table/Table';

export default Table;

export * from 'common/ui/components/Table/Table';
export * from 'common/ui/components/Table/tableUtils';
export * from 'common/ui/components/Table/types';
